import Message from './Message';

export default (function (w, d) {
    'use strict';

    function FlashMessage() {
        if (window.flashMessage !== undefined) {
            new Message(window.flashMessage, 'success');
        }
    }

    return FlashMessage;
}(window, document));

